import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { cva } from 'class-variance-authority';

const alertVariants = cva(
  'relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-md border px-2.5 py-2 text-sm has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-2 [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current',
  {
    variants: {
      variant: {
        default: 'bg-card text-card-foreground',
        success:
          'bg-success-accent/75 dark:bg-success/15 border-border-success-accent dark:border-border-success/50 text-text-success *:data-[slot=alert-description]:text-success/90 [&>svg]:text-current',
        warning: 'bg-warning-accent/75 dark:bg-warning/15 border-border-warning-accent dark:border-border-warning/50 text-warning *:data-[slot=alert-description]:text-warning/90 [&>svg]:text-current',
        destructive:
          'bg-destructive-accent/75 dark:bg-destructive/15 border-border-destructive-accent dark:border-border-destructive/50 text-destructive *:data-[slot=alert-description]:text-destructive/90 [&>svg]:text-current',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export function Alert(alertProps: ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  const { className, variant, ...props } = alertProps;
  return <div data-slot="alert" role="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}

export function AlertTitle(alertTitleProps: ComponentProps<'div'>) {
  const { className, ...props } = alertTitleProps;
  return <div data-slot="alert-title" className={cn('col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight', className)} {...props} />;
}

export function AlertDescription(alertDescriptionProps: ComponentProps<'div'>) {
  const { className, ...props } = alertDescriptionProps;
  return (
    <div
      data-slot="alert-description"
      className={cn('text-accent-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed text-balance md:text-pretty', className)}
      {...props}
    />
  );
}
